import React from 'react'
import Span from '../Span';
import classNames from 'classnames'

const TagItem = ({ className, color, backgroundColor, label }) => {

  const isHasColor = !!(color && backgroundColor)

  return <Span
    className={classNames("ant-tag", className, {
      'ant-tag-has-color': isHasColor
    })}
    style={{ color, backgroundColor }}>{label}</Span>
}

export default TagItem